// extracted by mini-css-extract-plugin
export default {"breadCrumb":"BreadCrumb_breadCrumb__9R2z7"};